import React, { FC, Dispatch, useState, useEffect, memo } from 'react';
import Select from 'react-select';
import { AnyAction } from 'redux';
import eventService from '../../../common/eventService';
import BananatagButton from '../../../componentLibrary/BananatagButton';
import Modal from '../../../componentLibrary/Modal';
import FontSelect from '../../../componentLibrary/FontSelect';
import { DropdownIndicator, generateSelectStyles } from '../../../common/generateSelectStyling';
import * as Styled from './styles';
import * as columnItemActions from '../../../actions/columnItem';

const DEFAULT_HEIGHT = 275;

interface IProps {
    closeModal: () => void;
    dispatch: Dispatch<AnyAction>;
    missingFonts: Array<string>;
    canvasBlocks: Array<object>;
}

const ForceUpdateFont: FC<IProps> = ({ closeModal, missingFonts, canvasBlocks, dispatch }) => {
    const [newFonts, setNewFonts] = useState({});

    useEffect(() => {
        const newFontObj = missingFonts.reduce((acc, font) => {
            // Set a default font for each missing font.
            // Used a reduce for legibility & allows us to add more customizability if necessary in future.
            acc[font] = { value: "Arial" };
            return acc;
        }, {} as Record<string, object>);
        setNewFonts(newFontObj);
    }, [missingFonts]);

    const updateFonts = () => {
        dispatch(columnItemActions.updateColumnItemFontInMultipleBlocks({ elements: canvasBlocks, newFonts }));
        closeModal();
    }

    const calculateHeight = (): number => DEFAULT_HEIGHT + (60 * missingFonts.length)
    const missingMultiple: boolean = missingFonts.length > 1;

    return (
        <Modal height={calculateHeight()} width={550}>
            <Styled.Body>
                <Styled.Header>Font{missingMultiple ? 's' : ''} removed</Styled.Header>
                <Styled.Text>
                    One or more fonts have been removed from your organization. Please select a replacement font to
                    continue.
                </Styled.Text>
                <div className="inputs">
                    {missingFonts.map((missingFont) => (
                        <div className="input">
                            <div>
                                <Styled.TitleText>Removed Font</Styled.TitleText>
                                <Select
                                    components={{ DropdownIndicator }}
                                    onChange={() => {}}
                                    options={[]}
                                    className="removed-font"
                                    // eslint-disable-next-line
                                    isDisabled={true}
                                    styles={generateSelectStyles({})}
                                    defaultValue={{ label: missingFont, key: missingFont }}
                                />
                            </div>
                            <Styled.Icon icon="arrow-right" />
                            <div>
                                <Styled.TitleText>Replacement Font</Styled.TitleText>
                                <FontSelect
                                    // @ts-ignore
                                    value={newFonts[missingFont]?.value}
                                    width={140}
                                    marginBottom={0}
                                    type="fontFamily"
                                    label="Font Family"
                                    onChange={(selectedOption) => {
                                        const selectedFontFamilyValue = selectedOption.value.trim();
                                        // @ts-ignore
                                        if (selectedFontFamilyValue === newFonts[missingFont]?.value) {
                                            return;
                                        }

                                        const copy = {...newFonts};
                                        // @ts-ignore
                                        copy[missingFont] = { value: selectedFontFamilyValue, fontID: selectedOption.fontID };
                                        setNewFonts(copy);
                                    }}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </Styled.Body>
            <Styled.ButtonWrapper>
                <BananatagButton
                    type="clear"
                    size="large"
                    onClick={() => eventService.leaveDraft()}
                    text="Leave Draft"
                />
                <BananatagButton
                    type="solid"
                    size="large"
                    onClick={updateFonts}
                    text={`Replace Font${missingMultiple ? 's' : ''}`}
                />
            </Styled.ButtonWrapper>
        </Modal>
    );
};

export default memo(ForceUpdateFont);
